import { APPS_LANDING_SEO } from '@features/apps/constants'
import { createSeoHead } from '@shared/nuxt/createSeoHead'

/** Подготавливает SEO-данные страницы приложения. */
export const useAppsPage = () => {
  const { $host } = useNuxtApp()
  const route = useRoute()
  const { title, description } = APPS_LANDING_SEO

  return {
    title,
    seo: createSeoHead(
      $host,
      { title, keywords: '', description },
      route.fullPath,
      route.path,
    ),
  }
}
